export default "__VITE_ASSET__Bxpt2S9p__"